"use client";

import PowerDialerDetail from "../../../../components/PowerDialer/PowerDialerDetail";

export default function PowerDialerDetailPage() {
  return <PowerDialerDetail />;
}
